import { render } from "./Contact_page_en_m.vue?vue&type=template&id=8332322e&scoped=true"
import script from "./Contact_page_en_m.vue?vue&type=script&lang=js"
export * from "./Contact_page_en_m.vue?vue&type=script&lang=js"

import "./Contact_page_en_m.vue?vue&type=style&index=0&id=8332322e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8332322e"

export default script